module.exports = __webpack_public_path__ + "img/icon2.c7bd4fbe.png";